import moment from 'moment';
import getString from '@/helpers/GetStrings';
import BrochuresStatistics from './components/BrochuresStatistics.vue';
import UsagesStatistics from './components/UsagesStatistics.vue';
import LoginsStatistics from './components/LoginsStatistics.vue';
import SyncInfoStatistics from './components/SyncInfoStatistics.vue';
import AccountsStatistics from './components/AccountsStatistics.vue';
import OrdersStatistics from './components/OrdersStatistics.vue';
import HolidaysStatistics from './components/HolidaysStatistics.vue';
import CartItemStatistics from './components/CartItemStatistics.vue';
import QuotationsStatistics from './components/QuotationsStatistics.vue';
import InvoicesStatistics from './components/InvoicesStatistics.vue';
import GiftPromotionStatistics from './components/GiftPromotionStatistics.vue';
import IccDownloadsStatistics from './components/IccDownloadsStatistics.vue';
import RequestsStatistics from './components/RequestsStatistics.vue';

// In this folder, common variables can be accessed and edited in a single place.
export default {
  components: {
    BrochuresStatistics,
    UsagesStatistics,
    LoginsStatistics,
    SyncInfoStatistics,
    AccountsStatistics,
    OrdersStatistics,
    HolidaysStatistics,
    CartItemStatistics,
    QuotationsStatistics,
    InvoicesStatistics,
    GiftPromotionStatistics,
    IccDownloadsStatistics,
    RequestsStatistics,
  },
  data() {
    return {
      dataReady: false,
      statsConfig: {
        startDate: moment().subtract(29, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        module: 'dashboard',
      },
      lastUpdate: null,
    };
  },
  methods: {
    getString,
    // return the entire name of the Vue component
    registeredComponent(name) {
      const componentName = `${name.charAt(0).toUpperCase() + name.slice(1)}Statistics`;
      return componentName in this.$options.components ? componentName : null;
    },
    setLastUpdate() {
      this.lastUpdate = moment(Date.now()).format(this.$store.state.meStore.me.settings.time);
    },
    fetchData() {
      this.dataReady = false;
      this.$store.dispatch('loadStatisticsConfig', this.statsConfig);
      this.$store.dispatch('loadStatistics').then(() => {
        this.dataReady = true;
      });
      this.setLastUpdate();
    },
  },
  computed: {
    componentsByRights() {
      return this.$store.getters.componentsByRights;
    },
    getRights() {
      return Object.keys(this.componentsByRights).sort();
    },
    lastUpdatedString() {
      return this.$store.state.stringsStore.strings.datetime.updatedTime.replace('%time%', this
        .lastUpdate);
    },
  },
  mounted() {
    this.fetchData();
  },
};
